import React from 'react'
import PropTypes from 'prop-types'
import { DateTime } from 'luxon'
import cx from 'classnames'

import isEmpty from 'lodash/isEmpty'

import { useFulfillment } from '../FulfillmentProvider/FulfillmentProvider'

import './FulfillmentDisplay.css'
import { IfOutpost, UnlessOutpost } from '../IfOutpost/IfOutpost'
import { useOutpost } from '../OutpostProvider/OutpostProvider'
import { FlagOff, FlagOn } from '../FeatureFlag/FeatureFlag'
import { getFormattedDiningOption } from '../FulfillmentSelectorModal/fulfillment-helpers'
import { AsapEstimate } from '../AsapEstimate/AsapEstimate'
import { getFormattedAddress } from '../../utils/address-helpers'
import { FutureEstimate } from '../FutureEstimate/FutureEstimate'
import { DeliveryProviderLabel } from '../DeliveryProviderLabel/DeliveryProviderLabel'
import Pencil from '../../assets/pencil.svg'

// Fulfillment display bar (which will open modal upon click as well as prior to having fulfillment selected e.g. on first menu load)
export const FulfillmentDisplay = ({
  editable,
  outpostName,
  outpostDeliveryTime,
  showDeliveryAddress = false,
  inline = false,
  centered = false
}) => {
  const { isOutpost } = useOutpost()
  const { fulfillmentType, diningOptionBehavior, deliveryInfo, deliveryProvider } = useFulfillment()
  const formattedDiningOption = getFormattedDiningOption(diningOptionBehavior)

  const ASAP = () => (
    <span data-testid='fulfillment-asap-ready-time' styleName='emphasis'>
      now (<AsapEstimate diningOptionBehavior={diningOptionBehavior} />)
    </span>
  )

  if (isOutpost) {
    editable = false
  }

  return (
    <div styleName={cx('fulfillmentDisplay', { editable })}>
      <IfOutpost>
        <span>
          <span styleName='emphasis'>Pickup</span>
          &nbsp;at&nbsp;
          <span styleName='emphasis'>{outpostName}</span>
          { outpostDeliveryTime
            ? <span>at<span styleName='emphasis'> {DateTime.fromISO(outpostDeliveryTime).toLocaleString(DateTime.TIME_SIMPLE)} </span></span>
            : <span>is<span styleName='emphasis'> unavailable today </span></span>
          }
        </span>
      </IfOutpost>
      <UnlessOutpost>
        <div styleName={cx('fulfillmentInfo', { centered })}>
          <div styleName={cx('fulfillmentRows', { inline })}>
            <div styleName='fulfillmentRow'>
              <FlagOff name='oo-v3-delivery'>
                <span data-testid='fulfillment-type' styleName='emphasis'>Pickup</span>
              </FlagOff>
              <FlagOn name='oo-v3-delivery'>
                <span data-testid='fulfillment-type' styleName='emphasis'>{formattedDiningOption}</span>
              </FlagOn>
              &nbsp;for&nbsp;
              {fulfillmentType === 'ASAP' ? <ASAP /> : <FutureEstimate editable={editable} />}
              {editable && <Pencil styleName='pencil' />}
            </div>
            <FlagOn name='oo-v3-delivery'>
              { showDeliveryAddress && !isEmpty(deliveryInfo) && (
                <div styleName='fulfillmentRow'>
                  to <span styleName='emphasis'> {getFormattedAddress(deliveryInfo)}</span>
                </div>
              ) }
              <div styleName='deliveryProvider'>
                <DeliveryProviderLabel deliveryProvider={deliveryProvider} />
              </div>
            </FlagOn>
          </div>
        </div>
      </UnlessOutpost>
    </div>
  )
}

FulfillmentDisplay.propTypes = {
  editable: PropTypes.bool,
  outpostName: PropTypes.string,
  outpostDeliveryTime: PropTypes.string,
  showDeliveryAddress: PropTypes.bool,
  centered: PropTypes.bool,
  inline: PropTypes.bool
}
